import { Box } from "@mui/material"

export const ContactPage = () => {
    return (
        <Box><h1>ContactsPage</h1></Box>
    )
}